import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Button, Card } from '@totalsoft/rocket-ui';
import { PartnerLabel } from '../BrowserStyle';

const BrowserComponentPF = ({ pfPartners, handleSaveData }) => {
  const [t] = useTranslation();

  return (
    <Grid container flexDirection='column' gap={1} sx={theme => ({ fontFamily: theme.typography.fontFamily })}>
      {pfPartners?.map((value, idx) => {
        return (
          <Card key={value.uniqueId + idx} disablePadding>
            <Grid container gap={2} height='100%' py={0.5} px={2} alignItems={'center'} flexWrap='nowrap'>
              <Grid item container width='auto' flexGrow={1}>
                <Grid item xs={12} md={4} sm={6}>
                  <PartnerLabel>{t('OfferEdit.Client.Name')}:</PartnerLabel> <span>{value.fullName}</span>
                </Grid>
                <Grid item xs={12} md={4} sm={6}>
                  <PartnerLabel>{t('OfferEdit.Client.PersonalIdentifier')}:</PartnerLabel> <span>{value.uniqueId}</span>
                </Grid>
                <Grid item xs={12} md={4} sm={6}>
                  <PartnerLabel>{t('OfferEdit.Client.Citizenship')}:</PartnerLabel> <span>{value.citizenship}</span>
                </Grid>
                <Grid item xs={12} md={4} sm={6}>
                  <PartnerLabel>{t('OfferEdit.Client.Nationality')}:</PartnerLabel> <span>{value.nationality}</span>
                </Grid>
                <Grid item xs={12} md={4} sm={6}>
                  <PartnerLabel>{t('OfferEdit.Client.PassportSeriesAndNumber')}:</PartnerLabel> <span>{value.idSeriesAndNumber}</span>
                </Grid>
                <Grid item xs={12} md={4} sm={6}>
                  <PartnerLabel>{t('OfferEdit.Client.BirthDate')}:</PartnerLabel> <span>{value.birthDate}</span>
                </Grid>
                <Grid item xs={12} md={4} sm={6}>
                  <PartnerLabel>{t('OfferEdit.Client.Country')}:</PartnerLabel> <span>{value.country}</span>
                </Grid>
                <Grid item xs={12} md={4} sm={6}>
                  <PartnerLabel>{t('OfferEdit.Client.County')}:</PartnerLabel> <span>{value.county}</span>
                </Grid>
                <Grid item xs={12} md={4} sm={6}>
                  <PartnerLabel>{t('OfferEdit.Client.City')}:</PartnerLabel> <span>{value.city}</span>
                </Grid>
              </Grid>
              <Grid item>
                <Button
                  onClick={() => {
                    handleSaveData(idx);
                  }}
                >
                  {t('Select')}
                </Button>
              </Grid>
            </Grid>
          </Card>
        );
      })}
    </Grid>
  );
};

BrowserComponentPF.propTypes = {
  pfPartners: PropTypes.array,
  handleSaveData: PropTypes.func.isRequired
};

export default BrowserComponentPF;
